import { Search, Flame, BellRing } from "lucide-react";
import { SectionHeading, Reveal } from "@/components/Reveal";

const STEPS = [
    {
        n: "01",
        icon: Search,
        title: "Cerchiamo",
        text: "Monitoriamo Amazon alla ricerca di prezzi realmente interessanti.",
    },
    {
        n: "02",
        icon: Flame,
        title: "Selezioniamo",
        text: "Filtriamo le offerte e segnaliamo quelle che vale davvero la pena guardare.",
    },
    {
        n: "03",
        icon: BellRing,
        title: "Ti avvisiamo",
        text: "Ricevi direttamente su Telegram le offerte più interessanti.",
    },
];

export default function HowItWorks() {
    return (
        <section id="come-funziona" data-testid="come-funziona" className="scroll-mt-24 py-20 sm:py-28">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <SectionHeading
                    eyebrow="Come funziona"
                    title={
                        <>
                            Tu risparmi.
                            <br className="hidden sm:block" /> Noi cerchiamo le offerte.
                        </>
                    }
                />

                <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-7">
                    {STEPS.map((s, i) => (
                        <Reveal key={s.n} delay={i * 0.12} className="h-full">
                            <article
                                data-testid={`how-card-${i}`}
                                className="spotlight group relative flex h-full flex-col overflow-hidden rounded-3xl border border-ink/5 bg-white p-8 shadow-[0_10px_30px_-10px_rgba(11,18,32,0.06)] transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_28px_60px_-18px_rgba(34,158,217,0.25)]"
                            >
                                <span
                                    aria-hidden
                                    className="pointer-events-none absolute -top-3 right-4 font-mono text-[5.5rem] font-extrabold leading-none text-ink/[0.05] transition-colors duration-500 group-hover:text-telegram/15"
                                >
                                    {s.n}
                                </span>

                                <div className="mt-2 inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-telegram-light text-telegram-deep transition-all duration-500 group-hover:bg-telegram group-hover:text-white group-hover:shadow-[0_12px_25px_-8px_rgba(34,158,217,0.5)]">
                                    <s.icon className="h-6 w-6" />
                                </div>
                                <h3 className="mt-5 font-display text-xl font-semibold tracking-tight text-ink sm:text-2xl">
                                    {s.title}
                                </h3>
                                <p className="mt-3 text-[15px] leading-relaxed text-slate-500">{s.text}</p>
                            </article>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
